import gql from 'graphql-tag';

export const getFacilityNotepadCategories = gql`
  query getFacilityNotepadCategories {
    getFacilityNotepadCategories {
      id
      name
    }
  }
`;
